<template>
  <div class="page page-with-bg">
    <div class="page-form-wrap">
      <div class="page-form-header">
        <h1>Two Factor Authentication</h1>
        <div class="description">
          The 6-digit verification code has been sent to your <br />
          email address. <br />
          Please enter the code below
        </div>
      </div>
      <div class="page-form-content">
        <b-form @submit.prevent="submit">
          <validation-summary :errors="errors"></validation-summary>
          <v-form-group :validator="$v.code"
                        label="Code">
            <b-form-input slot-scope="{ attrs, delayedListeners }"
                          v-bind="attrs"
                          v-on="delayedListeners"
                          v-model="code"
                          type="text"
                          placeholder="Code" />
          </v-form-group>

          <b-form-group class="text-right mt-3">
            <a class="text-secondary pointer" @click="resendEmail()">Resend verification email</a>
          </b-form-group>

          <div class="d-flex justify-content-between mt-3">
            <b-button :loading="loading" size="lg" variant="success" type="submit">Verify</b-button>
            <b-button :loading="loading" variant="secondary" @click="logout()">Log Out</b-button>
          </div>
        </b-form>
      </div>
    </div>
  </div>
</template>

<script>
  import { required } from "vuelidate/lib/validators";
  import formMixin from "mixins/form-mixin";
  import accountService from "services/account-service"

  export default {
    mixins: [formMixin],

    data() {
      return {
        code: null,
      };
    },

    validations: {
      code: {
        required
      },
    },

    created() {

    },

    methods: {
      getAfterLoginRedirect() {
        if (this.$auth.userInfo.roles.some(r => r === "Admin"))
          return "/reports";

        return this.$route.query.redirect || "/";
      },

      async onSubmit() {
        await this.$auth.login(
          null,
          null,
          false,
          this.getAfterLoginRedirect(),
          "two_factor_auth",
          this.$auth.tokenData.accessToken,
          this.code
        );
      },

      logout() {
        this.$auth.logout();
      },

      async resendEmail() {
        let response = await accountService.sendTwoFactorAuthEmail(this.$auth.userInfo.sub)

        if (response.isSuccess)
          this.$root.successToast("Email has been sent");
        else
          this.$root.errorToast("Problem occured while sending out email");
      }
    }
  };
</script>

<style scoped lang="scss">
  @import '@/styles/_mixins';

  .pointer {
    cursor: pointer;
  }

  .page {
    @include retina('/png/stethoscope.png');
  }
</style>